/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teams_No_Teams_Try_Adjust_SearchInputs */



/**
* | output |
* | --- |
* | "Try adjusting your search criteria" |
*
* @param {Teams_No_Teams_Try_Adjust_SearchInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const teams_no_teams_try_adjust_search = /** @type {((inputs?: Teams_No_Teams_Try_Adjust_SearchInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teams_No_Teams_Try_Adjust_SearchInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Versuche deine Suchkriterien anzupassen")
	return /** @type {LocalizedString} */ ("Try adjusting your search criteria")
});